import React from "react";
import HeroSection from "../HeroSection";
import AgentsSection from "../AgentsSection";
import FeaturesSection from "../FeaturesSection";
import PropertyCard from "../PropertyCard";
import ServicesSection from "../ServicesSection";

function Home() {
  return (
    <div>
      <HeroSection />
      <PropertyCard />
      <FeaturesSection />
      <ServicesSection />
      <AgentsSection />
    </div>
  );
}

export default Home;
